<div *transloco="let t">
	<ng-template #consumptionContent let-energyValue>
		<!--        <div [ngClass]="{'w-[100%]': isMobile, 'w-[50%]': !isMobile}" style="padding-left: 25px; padding-top: 25px;">-->
		<!--            <div [ngClass]="{'w-[100%]': isMobile, 'w-[50%]': !isMobile}"[style]="{ 'isMobile':'padding-left: 25px;'? padding-top: 25px;}">-->
		<div
			[ngClass]="{ 'w-[100%]': isMobile, 'w-[50%]': !isMobile }"
			[ngStyle]="{
				'padding-left': isMobile ? '5px' : '25px',
				'padding-top': '25px',
			}">
			<div class="uvi-my-consumption padding-left-20 subheading-2 flex flex-row flex-wrap">
				<div [ngClass]="{ 'w-[100%]': isMobile, 'w-[60%]': !isMobile }" class="flex flex-col">
					<h4>{{ t('uvi.yourConsumption') }}</h4>
				</div>
				<div
					[ngStyle]="{ 'text-align': isMobile ? 'start' : 'end' }"
					[ngClass]="{ 'w-[40%]': isMobile, 'w-[20%]': !isMobile }"
					class="flex flex-col items-center">
					{{ roundConsumptionValuesByCostType(energyValue) }}
				</div>
			</div>

			<div style="height: 10px"></div>

			@if (energyValue.costType !== CostTypeEnum.COLDWATER) {
				<div class="flex flex-row flex-wrap uvi-default-consumption padding-left-20">
					<div class="subheading-2 flex flex-col" [ngClass]="{ 'w-[100%]': isMobile, 'w-[60%]': !isMobile }">
						<h4>
							{{ getTitleByCostType(energyValue) }}
						</h4>
					</div>
					<div
						[ngStyle]="{ 'text-align': isMobile ? 'start' : 'end' }"
						[ngClass]="{ 'w-[40%]': isMobile, 'w-[20%]': !isMobile }"
						class="flex flex-col items-center">
						<div>
							{{ replaceDecimalSeparatorByLocale(numberUtil.roundConsumptionValues(energyValue.averageConsumption, 0)) }} {{ t('enum.KWH') }}
						</div>
					</div>
					@if (energyValue.averageDinCalculation) {
						<div
							[ngStyle]="{ 'text-align': isMobile ? 'start' : 'end' }"
							[ngClass]="{ 'w-[20%]': isMobile, 'w-[10%]': !isMobile }"
							class="flex flex-col items-center">
							<div>
								<mat-icon [siTooltip]="t('uvi.avgConsumptionInfo')" [svgIcon]="icons.get('infoOutline')" color="primary"></mat-icon>
							</div>
						</div>
					}
				</div>
			}
			<div class="flex flex-row justify-center items-center">
				@if (energyValue.averageConsumption && energyValue.currentConsumptionPeriod?.totalConsumptionAsKwh) {
					<div class="rating-box subheading-2">
						<h4 class="w-[10%]">
							@if (energyValue.averageConsumption > energyValue.currentConsumptionPeriod?.totalConsumptionAsKwh) {
								<mat-icon [ngClass]="isMobile ? 'rating-icon' : 'rating-icon desktop'" [svgIcon]="icons.get('thumbUp')"></mat-icon>
							}
							@if (energyValue.averageConsumption < energyValue.currentConsumptionPeriod?.totalConsumptionAsKwh) {
								<mat-icon [ngClass]="isMobile ? 'rating-icon' : 'rating-icon desktop'" [svgIcon]="icons.get('warning')"></mat-icon>
							}
						</h4>
						<h4 [ngClass]="isMobile ? 'rating-text-mobile' : ''" class="w-[90%]">
							@if (energyValue.averageConsumption > energyValue.currentConsumptionPeriod?.totalConsumptionAsKwh) {
								<span>
									{{ t('uvi.consumeLessAverage') }}
								</span>
							}
							@if (energyValue.averageConsumption < energyValue.currentConsumptionPeriod?.totalConsumptionAsKwh) {
								<span>
									{{ t('uvi.consumeMoreAverage') }}
								</span>
							}
						</h4>
					</div>
				}
			</div>
		</div>
	</ng-template>

	<div class="p-6" style="margin-bottom: 10px">
		<div>
			<div class="flex flex-row flex-wrap">
				<div [ngClass]="{ 'w-[100%]': isMobile, 'w-[50%]': !isMobile }" class="flex flex-row">
					<p [ngClass]="setBarStyleByDevice('left')">
						{{
							formatDataLabel(
								consumption().costType === CostTypeEnum.COLDWATER
									? consumption().lastYearConsumptionPeriod.totalConsumption
									: consumption().lastYearConsumptionPeriod.totalConsumptionAsKwh,
								consumption().costType
							)
						}}
					</p>
					<p [ngClass]="setBarStyleByDevice('mid')">
						{{
							formatDataLabel(
								consumption().costType === CostTypeEnum.COLDWATER
									? consumption().lastMonthConsumptionPeriod.totalConsumption
									: consumption().lastMonthConsumptionPeriod.totalConsumptionAsKwh,
								consumption().costType
							)
						}}
					</p>
					<p [ngClass]="setBarStyleByDevice('right')">
						{{
							formatDataLabel(
								consumption().costType === CostTypeEnum.COLDWATER
									? consumption().currentConsumptionPeriod.totalConsumption
									: consumption().currentConsumptionPeriod.totalConsumptionAsKwh,
								consumption().costType
							)
						}}
					</p>
					<ngx-charts-bar-vertical
						[barPadding]="3"
						[customColors]="customColors"
						[gradient]="false"
						[legendTitle]="t('uvi.legend')"
						[legend]="false"
						[ngClass]="!isMobile ? 'margin-left-40' : ''"
						[results]="getChartDataByCostType(consumption().costType)"
						[roundDomains]="true"
						[showYAxisLabel]="showYAxisLabel"
						[view]="diagramSize"
						[xAxisTickFormatting]="xAxisTickFormattingFn"
						[xAxis]="showXAxis"
						[yAxisLabel]="t('uvi.diagramConsumption')"
						[yAxisTickFormatting]="yAxisTickFormattingFn"
						[yAxis]="showYAxis"
						id="chart_heat">
						<ng-template #tooltipTemplate let-model="model">
							<span class="tooltip-label">{{ model.name }}</span>
							<span class="tooltip-value">{{ scaleByCostType(model.value, consumption().costType) }}</span>
						</ng-template>
					</ngx-charts-bar-vertical>
					<mat-icon
						[ngClass]="layoutService.isMobile() ? 'tooltip-icon mobile' : 'tooltip-icon'"
						[siTooltip]="getTooltipByCostType(consumption().costType)"
						[svgIcon]="icons.get('infoOutline')"
						color="primary"></mat-icon>
				</div>
				<ng-template *ngTemplateOutlet="consumptionContent; context: { $implicit: consumption() }"></ng-template>
			</div>
		</div>
	</div>
	<ng-template #showSelectDateMessage>
		<div>
			<p>{{ t('uvi.selectDate') }}</p>
		</div>
	</ng-template>
</div>
